import { render, staticRenderFns } from "./TurnServers.vue?vue&type=template&id=128cb6be&"
import script from "./TurnServers.vue?vue&type=script&lang=js&"
export * from "./TurnServers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports